import { connect } from 'react-redux'

import { doSubmitOnboarding } from '@vrw/data/src/redux/profile/dispatchers'
import { doFetchTermsAndConditions } from '@vrw/data/src/redux/termsAndConditions/dispatchers'
import { doFetchPrivacyPolicy } from '@vrw/data/src/redux/privacyPolicy/dispatchers'

import { doShowDialog } from '@vrw/data/src/redux/dialog/dispatchers'
import { bindTypedActionCreators } from '../../../helpers/bindTypedActionCreators'
import { DispatchFunction } from '../../../redux/types'

import { TermsAndConditions } from './TermsAndConditions'

const mapDispatchToProps = (dispatch: DispatchFunction) =>
  bindTypedActionCreators(
    {
      doSubmitOnboarding,
      doFetchTermsAndConditions,
      doFetchPrivacyPolicy,
      doShowDialog,
    },
    dispatch
  )

const TermsAndConditionsContainer = connect(null, mapDispatchToProps)(TermsAndConditions)

export { TermsAndConditionsContainer }
